export interface InputTestPageObject {
    getType(): "Input";
    getValue(): string | undefined;
    setValue(value: string): void;
    isFocused(): boolean;
    isInView(): boolean;
}

export const inputTestAdapter = (
    value: string | undefined,
    container: HTMLElement | undefined,
    handleChange: (value: string) => void
): InputTestPageObject => ({
    getValue: () => value,
    getType: () => "Input",
    setValue: (nextValue: string | undefined) => {
        handleChange(nextValue ?? "");
    },
    isFocused: (): boolean => {
        const textareaElement = container?.querySelector("input");
        return document.activeElement === textareaElement;
    },
    isInView: (): boolean => {
        const rect = container?.getBoundingClientRect();
        return (
            rect != undefined &&
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= document.documentElement.clientHeight &&
            rect.right <= document.documentElement.clientWidth
        );
    },
});
